import Component from '../abstracts/Component';
import Cookies from 'js-cookie';
import NewsletterLogic from '../logics/NewsletterLogic';

export default class NewsletterComponent extends Component {
  get COMPONENTNAME() {
    return 'NewsletterComponent';
  }

  get SELECTORS() {
    return {
      newsletterFormWrapper: '.news__form__wrapper',
      form: '.js-newsletter-form',
      jsContent: '.js-modal-form-contents',
      submitButton: '.js-nl-submission',
      submitButtonMobile: '.js-nl-submission.mobile',
      privacyCheckbox: '#privacy-news',
      body: 'body',
      newsletterBox: '.w-newsletter',
      inputEmail: 'input[type=email]',
      contentBody: '.news__content__body'
    };
  }

  constructor(compEl) {
    super(compEl);
    // elements
    if(this.isMobile()) {
      this.submitButton = this.$component.querySelector(this.SELECTORS.submitButtonMobile);
    } else {
      this.submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    }

    this.privacyCheckbox = this.$component.querySelector(this.SELECTORS.privacyCheckbox);
    this.body = this.$component.querySelector(this.SELECTORS.body);
    this.newsletterBox = this.$component.querySelector(this.SELECTORS.newsletterBox);
  }

  // istantiate properties
  initProperties() {
    this.modalkey = $(document.body).data('nlKey') ? $(document.body).data('nlKey') : 'default_modal';
    this.hideCookieKey = 'nl_' + this.modalkey + '_hide';
    this.startTime = $(document.body).data('nlStartTime'); //new Date().setTime();
    this.endTime = $(document.body).data('nlEndTime'); //new Date().setTime();
    this.templateName = $(document.body).data('nlTemplate');
    this.link = $(document.body).data('nlLink') ? $(document.body).data('nlLink') : '/modals/newsletter';
  }

  // enable form submit button
  enableSubmitBtn() {
    let submitButton = this.$component.querySelector(this.SELECTORS.submitButton);
    if(this.isMobile()) {
      submitButton = this.$component.querySelector(this.SELECTORS.submitButtonMobile);
    }
    if (this.privacyCheckbox.checked === true) {
      submitButton.disabled = false;
    } else {
      submitButton.disabled = true;
    }
  }

  isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }


  // main events function
  bindEvents() {

    // enable submit
    this.privacyCheckbox.addEventListener('click', e => {
      this.enableSubmitBtn();
    });

    // DOM READY
    $(document).ready(() => {
      // check form
      this.enableSubmitBtn();
    });

    //
    this.$on('submit.newsletter', this.NewsletterLogic.subscribeToNewsletter, this.SELECTORS.newsletterBox, this.SELECTORS.form, this);
  }

  // main render function
  render() {
    this.log('Rendering...');
    // loading logics
    this.NewsletterLogic = new NewsletterLogic();
    // init vars
    this.initProperties();
    // go events
    this.bindEvents();
  }
}
